import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/containers/Root/index.tsx");
